import { HttpAuth } from '../../config/Http'
import { changeLoading } from './loading.action'
import { changeScreenB } from './navigation.action'
import { changeNotify } from './notify.action'
import { changeAlert } from './alert.action'

export const actionTypes = {
    INDEX: 'PRIZES_INDEX',
    STORE: 'PRIZES_STORE',
    UPDATE: 'PRIZES_UPDATE',
    DESTROY: 'PRIZES_DESTROY',
    CHANGE: 'PRIZES_CHANGE',
    SUCCESS: 'PRIZES_SUCCESS',
    ERROR: 'PRIZES_ERROR'
}

export const change = (payload) => ({
    type: actionTypes.CHANGE,
    payload
})

export const success = (payload) => ({
    type: actionTypes.SUCCESS,
    payload
})

export const error = (payload) => ({
    type: actionTypes.ERROR,
    payload
})

// INDEX

export const indexResponse = (payload) => ({
    type: actionTypes.INDEX,
    payload
})

export const index = (query) => dispatch => {
    return HttpAuth.get('/instant-prizes?'+ new URLSearchParams(query))
            .then(res => typeof res !== 'undefined' && dispatch(indexResponse(res.data)))
}

// STORE

export const store = (data, editor) => dispatch => { 
    dispatch(changeLoading({ 
        open: true,
        block: true
    }))

    return HttpAuth.post('/instant-prizes', data)
    .then(res => {
        if(typeof res !== 'undefined') {
            if(res.data.success === 200) {
                dispatch(changeNotify({
                    open: true,
                    msg: res.data.msg,
                    class: 'success'
                }))
                dispatch(success(true))
                dispatch(change('clear'))
                dispatch(index({
                    campaign_id: data.campaign_id,
                    editor: editor === 'editor' ? 'desc' : null
                })).then(e => dispatch(changeLoading({ open: false })))
                dispatch(changeScreenB({ open: false }))
            }
        }
    })
    .catch(erro => {
        if(erro.response) {
            if(erro.response.data.msg) {
                dispatch(changeAlert({
                    open: true,
                    msg: erro.response.data.msg,
                    class: 'error'
                }))
            }
        }
        dispatch(changeLoading({ open: false }))
    })
}

// SHOW

export const show = (id, position = null) => dispatch => {
    return HttpAuth.get('/instant-prizes/'+ id + (position ? '?position=1' : ''))
        .then(res => typeof res !== 'undefined' && dispatch(indexResponse(res.data)))
        .catch(erro => {
            if(erro.response) {
                dispatch(changeNotify({
                    open: true,
                    msg: erro.response.data.msg,
                    class: erro.response.data.class
                }))
                dispatch(success(true))
            }
        })
}

// UPDATE

export const updateResponse = (payload) => ({
    type: actionTypes.UPDATE,
    payload
})

export const update = (data, editor) => dispatch => {
    dispatch(changeLoading({ 
        open: true,
        block: true
    }))

    return HttpAuth.put('/instant-prizes/'+data.id, data)
        .then(res => {
            dispatch(changeLoading({ open: false }))

            if(typeof res !== 'undefined') {
                if(res.data.success === 200) {
                    dispatch(changeNotify({
                        open: true,
                        msg: res.data.msg,
                        class: 'success'
                    }))
                    dispatch(success(true))
                    dispatch(index({
                        campaign_id: data.campaign_id,
                        editor: editor === 'editor' ? 'desc' : null
                    }))
                    dispatch(changeScreenB({ open: false }))
                }
            }
        })
        .catch(erro => {
            if(erro.response) {
                if(erro.response.data.msg) {
                    dispatch(changeAlert({
                        open: true,
                        msg: erro.response.data.msg,
                        class: 'error'
                    }))
                }
            }
            dispatch(changeLoading({ open: false }))
        })
}

// DESTROY

export const destroyResponse = (payload) => ({
    type: actionTypes.DESTROY,
    payload
})

export const destroy = (id) => dispatch => {
    dispatch(changeLoading({ open: true }))

    return HttpAuth.delete('/instant-prizes/'+ id)
        .then(res => {
            dispatch(changeLoading({ open: false }))
            if(typeof res !== 'undefined') {
                dispatch(destroyResponse(id))
                dispatch(changeNotify({
                    open: true,
                    msg: res.data.msg,
                    class: 'success'
                }))
            }
        })
}

// EXAMPLE

export const getLinkExample = (domain) => dispatch => {
    dispatch(changeLoading({ 
        open: true,
        msg: 'Gerando link exemplo...'
    }))
    return HttpAuth.post('/instant-prizes/example')
        .then((res) => {
            if (res.status !== 200) throw new Error('Erro na resposta');

            dispatch(changeLoading({ 
                open: false,
                msg: 'Carregando...'
            }))
            
            if (res.status === 200) {
                const secureUrl = res.data.url.replace('http:', 'https:');
                const urlObj = new URL(secureUrl)
                const link = urlObj.search
                return 'https://'+domain+'/example'+link;
            }
        })
        .catch((error) => {
            dispatch(changeLoading({ 
                open: false,
                msg: 'Carregando...'
            }))
            
            dispatch(changeNotify({
                open: true,
                msg: 'Erro ao gerar link de exemplo.',
                class: 'error'
            }))
        });
}